import {CircularProgress} from '@material-ui/core';
import React from 'react';
import {useSelector} from 'react-redux';

const AppReloader = ({children}) => {
  const reload = useSelector((state) => state.i18nReducer.reload);
  if (reload)
    return (
      <div style={{}}>
        <CircularProgress
          style={{
            width: '50px',
            height: '50%',
            alignItems: 'center',
            display: 'flex',
            textAlign: 'center',
            minHeight: '100vh',
            flexDirection: 'column',
            justifyContent: 'center',
            margin: 'auto',
          }}
          disableShrink
        />
      </div>
    );
  else {
    return children;
  }
};

export default AppReloader;
